<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      :loading="isLoading"
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem>
      <general-error v-if="!!generalError" />
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <v-row v-if="showGeneralInfo">
        <v-col class="text-right">
          <btn-icon-tip
              v-if="showGeneralInfo"
              :id="`getRegCard`"
              icon="description"
              :tip="$t('Скачать регистрационную карточку')"
              @click="getRegistrationCard" />
        </v-col>
      </v-row>
      <organization-info-view
          v-if="showGeneralInfo"
          :organization-info="organization" />
      <identity-document-list-view
          v-if="showDocuments"
          :request-files="requestFiles"
          :document-types="requiredDocumentTypes"
          :loading="isLoading" />
      <contract-view
          v-if="showContract"
          :loading="isLoading"
          :contract="contract"
          :edited="initialize" />
      <bank-accounts-list
          v-if="showBankAccounts"
          show-status
          :bank-accounts="bankAccounts"
          :loading="isLoading"
          @change="initialize" />
    </template>
  </tab-list>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import OrganizationInfoView from '@/components/reused/organization/OrganizationInfoView.vue'
  import IdentityDocumentListView from '@/components/reused/files/IdentityDocumentListView.vue'
  import ContractView from '@/components/reused/organization/contract/ContractView.vue'
  import BankAccountsList from '@/components/reused/bankAccounts/BankAccountsList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { ORGANIZATION_TYPES, ORGANIZATION_TABS } from '@/constants/business'
  import { ORGANIZATION_TABS_ENUM } from '@/constants/enums'
  import { mapActions, mapState } from 'vuex'
  import { CURRENT_ORGANIZATION, IDENTITY_FILES } from '@/constants/store.js'
  import organizationMixin from '@/utils/mixins/scoped/organizationMixin.js'

  export default {
    components: {
      TabList,
      BtnIconTip,
      OrganizationInfoView,
      IdentityDocumentListView,
      BankAccountsList,
      ContractView,
      GeneralError
    },
    mixins: [organizationMixin],
    props: {
      tab: {
        type: String
      }
    },
    data () {
      return {
        isLoading: false,
        currentTab: this.tab || ORGANIZATION_TABS.GENERAL_INFO,
        defaultTab: ORGANIZATION_TABS.GENERAL_INFO
      }
    },
    computed: {
      ...mapState(CURRENT_ORGANIZATION.NAMESPACE, {
        organization: state => (state[CURRENT_ORGANIZATION.STATE.ORGANIZATION] || {})
      }),
      ...mapState(IDENTITY_FILES.NAMESPACE, {
        requiredDocumentTypes: state => (state[IDENTITY_FILES.STATE.REQUIRED_DOCUMENT_TYPES] || [])
      }),
      tabs () {
        const tabs = { ...ORGANIZATION_TABS_ENUM }

        return tabs
      },
      isIndividual () {
        return this.organization.organizationType === ORGANIZATION_TYPES.INDIVIDUAL
      },
      requestType () {
        return this.getRequestTypeByOrganization(
          this.organization.organizationType,
          this.organization.participantType,
          this.organization.isEIO)
      },
      showGeneralInfo () {
        return this.currentTab === ORGANIZATION_TABS.GENERAL_INFO
      },
      showDocuments () {
        return this.currentTab === ORGANIZATION_TABS.DOCUMENTS
      },
      showBankAccounts () {
        return this.currentTab === ORGANIZATION_TABS.BANK_ACCOUNTS
      },
      showContract () {
        return this.currentTab === ORGANIZATION_TABS.CONTRACT
      },
      title () {
        return `${this.$t('Просмотр организации')} ${this.organization.organizationShortName || ''}`
      },
      requestFiles () {
        return this.organization.files || []
      },
      bankAccounts () {
        return this.organization.bankAccounts || []
      },
      contract () {
        return this.organization.contract || {}
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.initialize()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(CURRENT_ORGANIZATION.NAMESPACE, {
        getCurrentOrganizationAction: CURRENT_ORGANIZATION.ACTIONS.GET_CURRENT_ORGANIZATION,
        getRegistrationCardAction: CURRENT_ORGANIZATION.ACTIONS.GET_REGISTRATION_CARD,
        clearCurrentOrganizationAction: CURRENT_ORGANIZATION.ACTIONS.CLEAR_CURRENT_ORGANIZATION
      }),
      ...mapActions(IDENTITY_FILES.NAMESPACE, {
        getRequiredDocumentTypesAction: IDENTITY_FILES.ACTIONS.GET_REQUIRED_DOCUMENT_TYPES,
        clearRequiredDocumentTypesAction: IDENTITY_FILES.ACTIONS.CLEAR_REQUIRED_DOCUMENT_TYPES
      }),
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/user/organization/${tabValue}`
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearCurrentOrganizationAction(),
            this.clearRequiredDocumentTypesAction()
          ])
      },
      initialize: async function () {
        this.isLoading = true
        try {
          await this.getCurrentOrganizationAction()
          await this.getRequiredDocumentTypesAction({
            requestType: this.requestType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getRegistrationCard: async function () {
        try {
          this.isLoading = true
          await this.getRegistrationCardAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
